export const securePath = (path: string) => path.startsWith("https");

export const sortRoutes = (a: string, b: string) => {
  const urlA = a.toUpperCase();
  const urlB = b.toUpperCase();
  if (urlA < urlB) return -1;
  if (urlA > urlB) return 1;
  return 0;
};
